import React from 'react';

import SesamLink from '../common/Links/SesamLink';
import { Form, FormActions } from '../common/forms';

export const NotConnectedMessage: React.FC = () => (
  <>
    <div>
      <h2 className="connect-message-title">Not connected</h2>
      <p>Subscription does not exist.</p>
    </div>
    <Form component="div">
      <FormActions>
        <SesamLink to={`/dashboard`}>Go to dashboard</SesamLink>
      </FormActions>
    </Form>
  </>
);
